import colors from "../../../../../../common/styles/colors";
import { makeStyles } from "@mui/styles";

export const deactivateDialogStyles = {
  container: {
    "& .MuiDialog-paper": {
      width: '600px',
      borderRadius: '10px',
      padding: '10px'
    }
  },
  content: {
    padding: '0px 25px'
  },
  buttons: {
    padding: '15px 25px'
  },
  subtitle: {
    fontSize: '15px'
  },
  table: {
    padding: '20px 0'
  },
  tableHeader: {
    backgroundColor: colors.grey[200],
    border: `1px solid ${colors.grey[250]}`,
    borderRadius: '8px 8px 0 0',
    padding: '10px 15px',
    fontSize: '15px',
    fontWeight: '600'
  },
  tableContent: {
    border: `1px solid ${colors.lightGrey3}`,
    borderTop: 'none',
    borderRadius: '0 0 8px 8px',
    maxHeight: '168px',
    overflowY: 'scroll',
  },
  tableRow: {
    padding: '3px 10px'
  },
  tableRowColored: {
    backgroundColor: colors.grey[200],
    padding: '3px 10px'
  },
  rowName: {
    color: colors.primary,
    fontSize: '15px',
    fontWeight: '600'
  },
  reasonInputField: {
    width: '100%',
    "& .MuiInputBase-root": {
      padding: '10px',
      fontSize: '14px'
    }
  },
  reasonLabel: {
    fontSize: '14px',
    fontWeight: '600',
    padding: '10px 0 8px 0'
  }
};

export const useStyles = makeStyles({
  title: {
    paddingBottom: '5px'
  }
});